import { Injectable } from '@angular/core';
import { InvoiceCategory, InvoiceCategoryConstants, InvoiceCategoryDisplayNames } from '../common/InvoiceCategory';
import {
  InvoiceType,
  InvoiceTypeConstants,
  InvoiceTypeDisplayNames,
} from '../common/InvoiceType';

@Injectable({
  providedIn: 'root',
})
export class ShopCommonService {
  constructor() {}

  public getInvoiceTypes(): InvoiceType[] {
    return [
      {
        Id: InvoiceTypeConstants.net,
        DisplayName: InvoiceTypeDisplayNames.InvoiceTypeDisplayNameNet,
      },
      {
        Id: InvoiceTypeConstants.gross,
        DisplayName: InvoiceTypeDisplayNames.InvoiceTypeDisplayNameGross,
      },
    ];
  }

  public getInvoiceCategories(): InvoiceCategory[] {
    return [
      {
        Id: InvoiceCategoryConstants.invoice,
        DisplayName: InvoiceCategoryDisplayNames.InvoiceCategoryDisplayNameInvoice,
      },
      {
        Id: InvoiceCategoryConstants.cancellation,
        DisplayName: InvoiceCategoryDisplayNames.InvoiceCategoryDisplayNameCancellation,
      },
    ];
  }
}
